// extracted by mini-css-extract-plugin
export default {"not_paid":"SelfPayItemPractice_not_paid__i1npE"};